import React, { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { PeekButton, PeekButtonGroup } from "@piiqtechnologies/ui-components";
import messages from "./messages.i18n";
const PERIODS = [1, 7, 30];
export const DatePeriodFilter = ({ form, field }) => {
    const intl = useIntl();
    const [period, setPeriod] = useState();
    useEffect(() => {
        if (field.value === undefined) {
            setPeriod(0);
        }
    }, [field.value]);
    useEffect(() => {
        if (period) {
            //@ts-ignore
            form.setFieldValue("startDate", "");
            //@ts-ignore
            form.setFieldValue("endDate", "");
        }
        //@ts-ignore
        form.setFieldValue(field.name, period);
    }, [period]);
    return (React.createElement(PeekButtonGroup, null, PERIODS.map((item) => {
        return (React.createElement(PeekButton, { size: "large", key: item, onClick: () => setPeriod(item), variant: period === item ? "contained" : "outlined", color: period === item ? "primary" : "info", sx: { textWrap: "nowrap" } }, item === 1
            ? intl.formatMessage(messages.filterDatesToday)
            : intl.formatMessage(messages.filterDatesDays, { days: item })));
    })));
};
export default DatePeriodFilter;
